<template>
  <div v-if="showModal">
    <b-modal
      @hide="cancel()"
      v-model="showModal"
      title="Асуулт"
      scrollable
      no-fade
      centered
    >
      {{ prms.promptMsg }}
      <template #modal-footer>
        <b-button @click="cancel" variant="danger">Болих</b-button>
        <b-button @click="ok" variant="primary">{{ prms.okMsg }}</b-button>
        <!-- <b-button @click="onReset" variant="danger">Болих</b-button>
        <b-button @click="onSubmit" variant="primary">Хадгалах</b-button>-->
      </template>
      <!-- <ButtonGroup slot="footer">
          <Button @click="cancel" icon="md-close">Болих</Button>
          <Button @click="ok" autofocus :type="prms.okType==undefined?'primary':prms.okType" 
          :icon="prms.okIcon==undefined?'md-checkmark':prms.okIcon">{{prms.okMsg}}</Button>
      </ButtonGroup>-->
    </b-modal>
    <!-- <Modal :transition-names="[]" :mask-closable="false" v-model="showModal" @on-cancel="cancel" title="Мэдэгдэл">
        
    </Modal>-->
  </div>
</template>

<script>
export default {
  name: "deleteModal",
  props: {
    id: {
      type: Number,
      default: () => 0
    },
    prms: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      isShow: true,
      infoModel: {
        info: String,
        default: () => ""
      }
    };
  },
  watch: {
    id: function(newVal) {
      //console.log(newVal);
      //console.log(this.prms);
      this.showModal = newVal > 0;
      // if (newVal > 0) {
      //   this.init();
      // }
    }
  },
  methods: {
    init() {},
    ok() {
      //this.$Message.info(this.infoModel.info);
      this.$emit("on-ok", this.prms);
    },
    cancel() {
      this.$emit("on-prompt-cancel", this.prms);
    }
  }
};
</script>
